'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/scroll-behavior/~/dom-helpers/util/inDOM.js
// module id = 317
// module chunks = 0